<template>
	<div :style="cssPropsCalendar" :class="template == 'fixed' ? 'field-container-date' : ''">
		<functional-calendar
			ref="Calendar"
			v-model="calendarData"
			:configs="getCalendarConfigs"
			v-on:choseDay="getDates"
			v-on:dayClicked="setBeforeLabelsArriveDeparture"
			v-on:changedMonth="setBeforeLabelsArriveDeparture"
			:transition="false"
			:newCurrentDate="getNewCurrentDate"
			:alwaysUseDefaultClasses="true"
		>
			<template v-if="showRates" v-slot:default="props">
				<div class="custom-day-container">
					<div class="custom-day" :class="[{ 'has-rate': hasRate(props.day.date), available: isAvailable(props.day.date), 'not-available': !isAvailable(props.day.date) }]">
						{{ props.day.day }}
						<div v-if="hasRate(props.day.date)" class="date-rate">
							<div v-html="hasRate(props.day.date)" />
						</div>
						<div v-if="!isAvailable(props.day.date)" class="rate-text">Not available</div>
					</div>
				</div>
			</template>
		</functional-calendar>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { FunctionalCalendar } from 'vue-functional-calendar';
import SymphonyBooking from '../lib/SymphonyBooking';
import SymphonyBookingAPI from '../services/SymphonyBookingAPI';
import { getStylesBookingCalendar } from '../lib/helpers';
export default {
	components: {
		FunctionalCalendar,
	},
	props: {
		calendar: Number,
		stylesCalendar: Object,
		arrowIcon: String,
		calendarIcon: String,
		template: String,
		minDate: String,
		stylesInputCalendar: Object,
		mergeDates: Boolean,
		bookingFieldsDate: Object,
		labelDate: String,
		formatDate: String,
		dayNames: String,
		monthNames: String,
		minDays: Number,
		showRates: Boolean,
		rates: Object,
	},
	methods: {
		togglePrevArrow(date, minDate) {
			const $prevArrow = document.querySelector('.vfc-cursor-pointer:has(.vfc-arrow-left)');
			if (!$prevArrow) return;

			const disabled = date.isBefore(minDate) || date.isBefore(dayjs());
			$prevArrow.style.visibility = disabled ? 'hidden' : 'visible';
		},
		getDates(data) {
			this.$emit('changeDates', this.calendarData.dateRange);
			if (this.template === 'fixed') this.fillInputDatesTemplateFixed();
		},
		setDisableAttribute() {
			document.querySelectorAll('.vfc-span-day.vfc-disabled').forEach((span) => {
				span.setAttribute('disabled', true);
			});
		},
		setBeforeLabelsArriveDeparture(date) {
			if (this.bookingFieldsDate.labelCalendar) {
				let labelCalendarArrive = 'none';
				let labelDepartureArrive = 'none';
				const labels = this.bookingFieldsDate['label'].split('/');
				labelCalendarArrive = labels[0];
				labelDepartureArrive = labels[1];
				setTimeout(() => {
					document.querySelectorAll('.vfc-week .vfc-day  span.vfc-start-marked').forEach((startDay) => {
						startDay.setAttribute('label-calendar-arrive', labelCalendarArrive);
					});
					document.querySelectorAll('.vfc-week .vfc-day  span.vfc-end-marked').forEach((endDay) => {
						endDay.setAttribute('label-calendar-departure', labelDepartureArrive);
					});
				}, 1);
			}

			/* #TOGGLE PREV ARROW */
			if (!(date instanceof Date)) return;
			this.togglePrevArrow(date ? dayjs(date) : dayjs(this.calendarData.dateRange.start, 'D-M-YYYY'), dayjs(this.minDate));
			/* /TOGGLE PREV ARROW */
		},
		fillInputDatesTemplateFixed() {
			const arriveDateFormat = SymphonyBooking.parseDate({
				date: this.calendarData.dateRange.start,
				format: this.formatDate,
			});
			const departureDateFormat = SymphonyBooking.parseDate({
				date: this.calendarData.dateRange.end,
				format: this.formatDate,
			});
			this.inputArrive.value = arriveDateFormat;
			this.inputDeparture.value = departureDateFormat;
		},
		selectDefaultDates() {
			if (!this.stylesInputCalendar['label-inside']) {
				this.calendarData = { ...this.calendarData, dateRange: SymphonyBooking.getInitialRangeDates(this.minDays, this.minDate) };
				this.$emit('changeDates', this.calendarData.dateRange);
				if (this.template === 'fixed') {
					this.fillInputDatesTemplateFixed();
				}
			}

			/* #TOGGLE PREV ARROW */
			if (!this.calendarData.dateRange) return;
			this.togglePrevArrow(dayjs(this.calendarData.dateRange.start, 'D-M-YYYY'), dayjs(this.minDate));
			/* /TOGGLE PREV ARROW */
		},
		calculateContainerCalendar() {
			//Calculate height for header calendar and assign its height to arrows container calendar
			let heightHeaderCalendar = 0;
			if (this.template === 'fixed') {
				//calculating the height of the widget
				document.querySelector('.vfc-main-container.vfc-modal').style.display = 'block';
				const headerCalendar = document.querySelector('.vfc-calendars-container .vfc-top-date.vfc-center');
				heightHeaderCalendar = headerCalendar.clientHeight;
				document.querySelector('.vfc-main-container.vfc-modal').style.display = 'none';

				//Wrap  inputs into a div
				const containerInputsDates = document.querySelector('.vfc-multiple-input');
				const inputArrive = containerInputsDates.children[0];
				const inputDeparture = containerInputsDates.children[1];
				const divArriveInput = document.createElement('div');
				const divDepartureInput = document.createElement('div');

				divArriveInput.setAttribute('class', 'input-container-date');
				divDepartureInput.setAttribute('class', 'input-container-date');

				containerInputsDates.insertBefore(divArriveInput, inputArrive);
				containerInputsDates.insertBefore(divDepartureInput, inputDeparture);

				// containerInputsDates.children[0].querySelector('label').setAttribute('for' , 'booking_cms_input_arrive_alt')

				//Input Arrive -Departure clone
				const inputArriveClone = document.createElement('input');
				const inputDepartureClone = document.createElement('input');

				inputArriveClone.setAttribute('type', 'text');
				inputDepartureClone.setAttribute('type', 'text');
				inputArriveClone.setAttribute('readonly', 'readonly');
				inputDepartureClone.setAttribute('readonly', 'readonly');
				inputArriveClone.setAttribute('id', 'booking_cms_input_arrive_alt');
				inputDepartureClone.setAttribute('id', 'booking_cms_input_departure_alt');

				divArriveInput.appendChild(inputArrive);
				divDepartureInput.appendChild(inputDeparture);

				divArriveInput.appendChild(inputArriveClone);
				divDepartureInput.appendChild(inputDepartureClone);

				// Insert Labels for input dates

				const labelArrive = this.labelDate.split('/')[0];
				const labelDeparture = this.labelDate.split('/')[1];

				const labelElementArriveDate = document.createElement('label');
				const textLabelArriveDate = document.createTextNode(labelArrive);
				const labelElementDepartureDate = document.createElement('label');
				const textLabelDepartureDate = document.createTextNode(labelDeparture);
				labelElementArriveDate.appendChild(textLabelArriveDate);
				labelElementDepartureDate.appendChild(textLabelDepartureDate);

				//ADA Labels
				labelElementArriveDate.setAttribute('for', 'booking_cms_input_arrive_alt');
				labelElementDepartureDate.setAttribute('for', 'booking_cms_input_departure_alt');

				if (this.stylesInputCalendar['label-inside']) {
					const inputsDOM = document.querySelectorAll('.vfc-multiple-input input');
					labelElementArriveDate.setAttribute('class', 'inside');
					labelElementDepartureDate.setAttribute('class', 'inside');
					inputsDOM.forEach((input) => {
						input.addEventListener('focus', () => {
							const paddings = this.stylesInputCalendar.padding.split(' ');
							const labelsDOM = document.querySelectorAll('.vfc-multiple-input label');
							const fontSize = `${Number(paddings[0].split('px')[0]) - 3}px`;
							labelsDOM[0].style.top = '4px';
							labelsDOM[1].style.top = '4px';
							labelsDOM[0].style.fontSize = this.stylesInputCalendar.fontSizeLabelInside;
							labelsDOM[1].style.fontSize = this.stylesInputCalendar.fontSizeLabelInside;
						});
					});
				}
				containerInputsDates.children[0].insertBefore(labelElementArriveDate, inputArrive);
				containerInputsDates.children[1].insertBefore(labelElementDepartureDate, inputDeparture);

				//clear place holders

				inputArrive.placeholder = '';
				inputDeparture.placeholder = '';
				inputArrive.style.display = 'none';
				inputDeparture.style.display = 'none';

				this.inputArrive = inputArriveClone;
				this.inputDeparture = inputDepartureClone;
			} else {
				const headerCalendar = document.querySelector('.vfc-calendars-container .vfc-top-date.vfc-center');
				heightHeaderCalendar = headerCalendar.clientHeight;
			}
			const arrowsContainer = document.querySelector('.vfc-separately-navigation-buttons.vfc-space-between');
			arrowsContainer.style.height = `${heightHeaderCalendar}px`;
			arrowsContainer.children[0].style.height = `${heightHeaderCalendar}px`;
			arrowsContainer.children[1].style.height = `${heightHeaderCalendar}px`;
		},

		hasRate(date) {
			const eventFind = this.events.find((event) => dayjs(event.date).format('D-M-YYYY') === date);
			let minDates = eventFind !== undefined && eventFind.min_date !== '' ? `<span class="minDate">Min ${eventFind.min_date} Nights</span>` : '';
			if (eventFind !== undefined) return eventFind.price === '0' || eventFind.price === '' ? false : `<span>$ ${eventFind.price}</span>${minDates}`;
			else return false;
		},
		isAvailable(date) {
			const eventFind = this.events.find((event) => dayjs(event.date).format('D-M-YYYY') === date);
			return eventFind !== undefined && eventFind.available === true ? true : false;
		},
	},
	data() {
		return {
			calendarData: {
				selectedDates: [],
			},
			calendarConfigs: {
				sundayStart: true,
				dateFormat: 'dd-mm-yyyy',
				calendarRates: {},
				isDatePicker: false,
				isDateRange: true,
				isMultiple: true,
				calendarsCount: window.screen.width < 1200 ? 1 : this.calendar,
				dayNames: this.dayNames.split(','),
				monthNames: this.monthNames.split(','),
				minSelDays: 2,
				sundayStart: true,
				transition: false,
			},
			inputArrive: null,
			inputDeparture: null,
			events: [],
		};
	},
	computed: {
		getCalendarConfigs() {
			/**
			 * This change is due to the fact that the minDate should be one day less
			 */
			//const disabledDates = SymphonyBooking.getRangeDates(this.minDate)
			let minDateExt = new Date(this.minDate);
			// minDateExt.setDate(minDateExt.getDate() - 1);
			minDateExt.setDate(minDateExt.getDate());
			const disabledDates = SymphonyBooking.getRangeDates(minDateExt.toISOString());
			if (this.template === 'fixed') {
				return {
					...this.calendarConfigs,
					isDateRange: true,
					isModal: true,
					isAutoCloseable: true,
					disabledDates: ['beforeToday', ...disabledDates],
				};
			} else {
				if (window.screen.width < 1200) {
					return {
						...this.calendarConfigs,
						calendarsCount: 1,
						disabledDates: ['beforeToday', ...disabledDates],
					};
				} else {
					return {
						...this.calendarConfigs,
						calendarCount: 2,
						disabledDates: ['beforeToday', ...disabledDates],
					};
				}
			}
		},
		cssPropsCalendar() {
			return {
				...getStylesBookingCalendar({
					stylesCalendar: this.stylesCalendar,
					stylesInputCalendar: this.stylesInputCalendar,
					template: this.template,
					calendarIcon: this.calendarIcon,
					mergeDates: this.mergeDates,
					arrowIcon: this.arrowIcon,
					calendarConfigs: this.calendarConfigs,
					bookingFieldsDate: this.bookingFieldsDate,
				}),
			};
		},
		getNewCurrentDate() {
			const todayObj = new Date(),
				minDateObj = new Date(this.minDate);
			if (minDateObj > todayObj) {
				return new Date(minDateObj.getFullYear(), minDateObj.getMonth(), 1);
			} else {
				return undefined;
			}
		},
	},
	async beforeMount() {
		if (this.showRates) {
			try {
				const hotelId = this.rates.hotelId,
					portalId = this.rates.portalId,
					numberOfMonths = this.rates.numberMonth,
					rateCode = this.rates.rateCode === '' ? null : this.rates.rateCode;

				if (hotelId !== undefined && hotelId !== '' && portalId !== undefined && portalId !== '') {
					const response = await SymphonyBookingAPI.getDayPricesFromTravelTripper(hotelId, portalId, rateCode, numberOfMonths);
					if (response.status === 200) {
						const dates = response.data.dates,
							prices = response.data.prices,
							min_los = response.data.min_los,
							available = response.data.available;
						this.events = dates.map((val, idx) => ({
							date: val,
							price: prices[idx],
							min_date: min_los[idx],
							available: available[idx],
						}));
					}
				}
			} catch (error) {
				this.events = [];
				console.log('Error Call api service:', error.message);
			}
		}
	},
	mounted() {
		this.calculateContainerCalendar();
		this.setDisableAttribute();
		setTimeout(() => {
			//Fixed bug with Min Date is greater than today of date in the future
			this.selectDefaultDates();
			this.setBeforeLabelsArriveDeparture();
		}, 500);
	},
};
</script>

<style lang="scss">
.vfc {
	&-calendars-container {
		overflow: visible;
	}
	//QA delete
	.vfc-base-start + .vfc-hide {
		opacity: 0 !important;
		background-color: transparent !important;
	}

	&-hide {
		opacity: 0 !important;
		pointer-events: none;
	}
	&-main-container {
		box-shadow: none;
		border-radius: 0;
		background-color: transparent;
		width: var(--width-container-calendars); // change depending total calendars
		font-family: var(--days-font-family);
		font-weight: var(--days-font-weight);
	}
	&-content {
		margin: 0 !important;
		background-color: var(--body-background-color);
	}
	&-dayNames {
		font-family: var(--weekdays-font-family);
		font-size: var(--weekdays-font-size);
		background-color: var(--weekdays-background-color);
		font-weight: 500;
		margin-bottom: 0;
		padding: 7px 0;
		margin-top: -1px;
		span {
			color: var(--weekdays-color);
			letter-spacing: var(--weekdays-letter-spacing);
			font-weight: var(--weekdays-font-weight);
			font-style: var(--weekdays-font-style);
			text-transform: var(--weekdays-text-transform);
		}
	}
	&-top-date {
		font-size: 13px;
		text-transform: uppercase;
	}
	&-separately-navigation-buttons {
		margin-top: 0;
		.vfc-cursor-pointer {
			margin: 1px 10px;
			background-image: var(--icon-arrow-calendar);
			background-repeat: no-repeat;
			background-position: center;
			&:first-child {
				transform: rotate(180deg);
			}
			.vfc-arrow-right,
			.vfc-arrow-left {
				opacity: 0;
			}
		}
	}

	&-calendars {
		width: var(--width-container-calendars); // change depending total calendars
		flex: inherit;
		flex-wrap: inherit;
	}

	&-calendar {
		flex: inherit;
		width: var(--width-calendar); // change here depends total calendars
		border: var(--body-border-color);
		background-color: var(--body-background-color);
		&:first-child {
			margin-right: var(--margin-calendar);
		}
		&:last-child {
			margin-left: var(--margin-calendar);
		}
	}
}
.vfc-top-date.vfc-center {
	background-color: var(--header-background-color);
	font-size: var(--header-font-size);
	font-family: var(--header-font-family);
	font-style: var(--header-font-style);
	font-weight: var(--header-font-weight);
	// margin: 0 0 -1px 0;
	margin: 0;
	padding: 10px;
	span {
		color: var(--header-color);
		text-transform: var(--header-text-transform);
		letter-spacing: var(--header-letter-spacing);
	}
}
.vfc-week .vfc-day span.vfc-span-day.vfc-marked {
	border-radius: 0;
	// &::before{
	//     height: calc(100% + 1px) !important;
	//     top: -1px;
	// }
	.minDate {
		opacity: 1;
	}
}
.vfc-week .vfc-day span.vfc-span-day.vfc-hover:hover,
.vfc-week .vfc-day span.vfc-span-day.vfc-hovered {
	background-color: var(--days-hover-background-color);
	color: var(--days-hover-color);
}
.vfc-week .vfc-day span.vfc-span-day.vfc-today {
	// background-color: transparent;
	background-color: var(--days-current-background-color);
	color: var(--days-current-color);
}
span.vfc-start-marked,
span.vfc-end-marked {
	background-color: var(--days-active-background-color) !important;
	color: var(--days-active-color) !important;
	&::before {
		position: absolute;
		left: 0;
		height: 15px !important;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 9px;
		background-color: var(--days-active-background-color) !important;
		color: var(--days-active-color) !important;
	}
}
.vfc-week .vfc-day span.vfc-start-marked[label-calendar-arrive] {
	&:before {
		content: attr(label-calendar-arrive) !important;
		position: absolute;
		top: -15px !important;
		border-top-right-radius: 5px;
		border-top-left-radius: 5px;
	}
}
.vfc-week .vfc-day span.vfc-end-marked[label-calendar-departure] {
	&:before {
		content: attr(label-calendar-departure) !important;
		position: absolute;
		top: 100% !important;
		border-bottom-right-radius: 5px;
		border-bottom-left-radius: 5px;
	}
}
.vfc-week .vfc-day .vfc-base-start,
.vfc-week .vfc-day .vfc-base-end {
	background-color: var(--days-between-background-color);
}
.vfc-week .vfc-day {
	margin-top: 0;
}
.vfc-week .vfc-day span.vfc-span-day.vfc-marked {
	background-color: var(--days-between-background-color);
	color: var(--days-between-color);
	&::before {
		background-color: var(--days-between-background-color);
	}
	.minDate {
		opacity: 1;
	}
}

.vfc-week .vfc-day span.vfc-span-day.vfc-disabled {
	color: var(--days-default-color) !important;
	opacity: 0.3;
	pointer-events: none;
	background: none !important;
}

.vfc-week .vfc-day:has(.custom-day.not-available) {
	span.vfc-span-day {
		opacity: 0.3;
		pointer-events: none;
	}
	.vfc-base-end {
		opacity: 0;
	}
	.rate-text {
		visibility: hidden;
	}
}

$x_svg: url("data:image/svg+xml,%3Csvg width='50' height='50' viewBox='0 0 50 50' fill='none' stroke='%23212121' stroke-width='1' stroke-opacity='0.6' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'%3E%3Cpath d='M 0 0 L 50 50 M 50 0 L 0 50' stroke-linecap='round'/%3E%3C/svg%3E%0A");
.vfc-week .vfc-day span.vfc-span-day .custom-day.not-available {
	filter: grayscale(1);
	&::before {
		background: $x_svg no-repeat center center / 100% 100%;
		display: block;
		position: absolute;
		inset: 0;
		z-index: 1;
		pointer-events: none;
		content: '';
	}
}

.vfc-week .vfc-day span.vfc-span-day.vfc-hide {
	color: var(--days-default-color);
}

.vfc-week .vfc-day span.vfc-span-day {
	border-radius: 0;
	font-size: var(--days-font-size);
	// width: var(--width-day);
	color: var(--days-default-color);
	// line-height: var(--line-height-day);
	line-height: 40px;
	width: 100%;
}

.vfc-week .vfc-day .vfc-base-start {
	background-color: transparent !important;
}
.has-rate {
	line-height: 1.8;
	.minDate {
		display: block;
		text-transform: uppercase;
		font-size: 0.35rem;
		opacity: 0;
	}
}
.not-available {
	//opacity: 0.5;
	.rate-text {
		font-size: 0.5rem;
		line-height: 1;
	}
}
.date-rate {
	font-size: 0.5rem;
	padding: 2px;
}

//Fixed booking

.field-container-date {
	// width: var(--input-container-width);
	line-height: 1;
	margin-right: 1%;
}

.vfc-multiple-input {
	display: flex;
	max-width: 420px;
	.input-container-date {
		width: 50%;
		position: relative;
		&:last-child {
			input {
				border-radius: 0;
				border-left: var(--input-last-border-left);
			}
		}
		&:first-child {
			margin-right: var(--input-first-margin-right);
			input {
				// width: var(--input-first-width);
				border-radius: 0;
				background-image: var(--input-first-background);
				border-right: var(--input-first-border-right);
			}
		}
		label {
			color: var(--input-color);
			font-family: var(--input-font-family);
			// font-size: var(--input-font-size);
			font-size: var(--input-label-font-size);
			text-transform: var(--input-text-transform);
			font-weight: var(--input-font-weight);
			line-height: var(--input-line-height);
		}

		label.inside {
			position: absolute;
			transition: all 0.2s ease;
			top: var(--input-padding-top);
			left: var(--input-padding-left);
			pointer-events: none;
		}
		input {
			text-align: left;
			border-top: var(--input-border-top);
			border-bottom: var(--input-border-bottom);
			border-left: var(--input-border-left);
			border-right: var(--input-border-right);
			background: transparent;
			color: var(--input-color);
			font-family: var(--input-font-family);
			font-size: var(--input-font-size);
			text-transform: var(--input-text-transform);
			font-weight: var(--input-font-weight);
			// width: var(--input-width);
			padding-top: var(--input-padding-top);
			padding-bottom: var(--input-padding-bottom);

			background-image: var(--input-calendar-icon);
			background-size: 17px;
			background-repeat: no-repeat;
			background-position: calc(100% - 15px) 50%;

			width: 100%;

			&::placeholder {
				content: '';
				color: var(--input-color);
				font-family: var(--input-font-family);
				font-size: var(--input-font-size);
				text-transform: var(--input-text-transform);
				font-weight: var(--input-font-weight);
				line-height: var(--input-line-height);
			}
		}
	}
}

.vfc-main-container.vfc-modal {
	//position
	bottom: var(--position-bottom-calendar);
	top: var(--position-top-calendar);
}

@media only screen and (max-width: 900px) {
	.field-container-date {
		width: 37%;
	}

	.vfc-multiple-input {
		.input-container-date {
			input {
				padding-left: 0;
				padding-right: 0;
			}
			&:first-child {
				input {
					width: 100%;
				}
			}
		}
	}
}
</style>
